import { TransformedCustomViewContainer } from "../../components/transformed_custom_view";
// Dedicated hub viewer (copy of the spoke Beta, hub cascade hardcoded — no flag).
import { SupplyWalkSingleForHubsViewerComponent } from "./viewer_component";
import { defaultConfig } from "../supply_walk_single/default_config";
import { PivotControl } from "../../constants/pivot_control_options";
import { paramsToTransformArgs } from "../supply_walk_single/params_to_transform_args";

export const SupplyWalkSingleForHubsContainer = () => {
  return (
    <TransformedCustomViewContainer
      viewControllerConfig={{
        datasetName: "supply_walk_test",
        transformId: "supply_walk_parallelized_for_hubs",
        folder: "outputs",
        title: "Supply Walk",
        viewContextSurfaceId: "supply-walk",
        dateHierarchyColumnFilter: {
          week: "week",
          month: "month",
          day: "day",
        },
        excludedSegmentationsFilter: [],
        measureColumnFilter: {},
        excludedFilterColumnFilter: [],
        showControls: [
          PivotControl.DateHierarchy,
          PivotControl.SegmentSelectMulti,
          PivotControl.FilterBy,
          PivotControl.DatePeriodPicker,
          PivotControl.ShowSettings,
          PivotControl.StoreAsDefault,
        ],
        paramsToTransformArgs: paramsToTransformArgs,
      }}
      defaultConfig={defaultConfig}
      viewerComponent={SupplyWalkSingleForHubsViewerComponent}
    />
  );
};
